export default "__VITE_PUBLIC_ASSET__4ea62502__"